import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=a77a2158&scoped=true&"
import script from "./Search.vue?vue&type=script&lang=js&"
export * from "./Search.vue?vue&type=script&lang=js&"
import style0 from "./Search.vue?vue&type=style&index=0&id=a77a2158&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77a2158",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIInfiniteHits: require('/opt/build/repo/components/UI/InfiniteHits.vue').default})
